import StepInfoAboutDamageForm from './stepInfoAboutDamageForm';

export default StepInfoAboutDamageForm;
